// extracted by mini-css-extract-plugin
export default {"optionsButtons":"styles_optionsButtons__zIKel"};